import { cookieConsentDisabled } from '../config';

// Maps the categories saved by CookiesNotification (see hocs/CookiesNotification) to the
// Storefront API's VisitorConsent input (analytics / marketing / preferences / saleOfData).
const getVisitorConsent = (cookieConsent) => {
	// No consent sent at all - Shopify falls back to its own default, as before the banner existed.
	if (cookieConsentDisabled) return null;

	const settings = Array.isArray(cookieConsent) ? cookieConsent : [];
	const hasAcceptedAll = settings.indexOf('all') !== -1;

	const hasAcceptedMarketing = hasAcceptedAll || settings.indexOf('marketing') !== -1;

	return {
		analytics: hasAcceptedAll || settings.indexOf('analytics') !== -1,
		marketing: hasAcceptedMarketing,
		// Functional/preference cookies are always granted on this site regardless of the
		// banner choice (see the functionality_storage/personalization_storage handling in
		// CookiesNotification.jsx), so preferences consent mirrors that.
		preferences: true,
		// No separate "do not sell my data" toggle exists in the banner, and declining
		// marketing is treated as also declining data sharing/sale, so this mirrors marketing.
		saleOfData: hasAcceptedMarketing,
	};
};

export default getVisitorConsent;
